
  import Vue from 'vue'
  import Component from "vue-class-component";
  import {Prop} from "vue-property-decorator";
  import {namespace} from "vuex-class";
  import {IOnOffHandlers} from "bonomo/dist";
  import {settings} from "@/plugins/settings";
  import {PermissionHelper} from "@/helpers/PermissionHelper";
  import {EUserPermissions} from "@/model/EUserPermissions";
  import {IAuthUserData} from "@/store/modules/authModule";

  const authModule = namespace("authModule");
  const lockerModule = namespace("lockerModule");

  @Component({
    name: 'LMScreen',
  })
  export default class LMScreen extends Vue {
    @Prop()
    protected lockerId!: number;

    private screenShotUrl: string = '';
    private showScreenShotDialog: boolean = false;
    private subscribes: IOnOffHandlers = {};
    private takeScreenShotLoading: boolean = false;

    @authModule.Getter('userData')
    protected authUser!: IAuthUserData;

    @lockerModule.Getter('screenShotToken')
    private screenShotToken!: string;

    protected get canLockerFactory() {
      const authUser = this.authUser;
      return PermissionHelper.hasPermission(authUser, EUserPermissions.PERMISSION_LOCKER_FACTORY, 1);
    }

    protected get canTakeScreenshot(): boolean {
      return !this.canLockerFactory;
    }

    protected created(): void {
      this.subscribes = this.$ons({
        'backend.call.begin.lockerUpdated': this.onSubmitting,
        'backend.call.OK.lockerUpdated': this.onSubmittingEnd,
        'backend.call.KO.lockerUpdated': this.onSubmittingEnd,
        'backend.call.begin.cellOpened': this.onSubmitting,
        'backend.call.OK.cellOpened': this.onSubmittingEnd,
        'backend.call.KO.cellOpened': this.onSubmittingEnd,
        'backend.call.OK.takeScreenShot': this.refreshScreenshotUrl,
        'backend.call.KO.takeScreenShot': this.refreshScreenshotUrl,
        'backend.call.OK.screenShotToken': this.screenShotTokenOk,
      });
      this.refreshScreenshotUrl();
    }
    beforeDestroy(): void {
      this.$offs(this.subscribes);
    }

    protected refreshScreenshotUrl() {
      this.takeScreenShotLoading = false;
      this.$store.dispatch('lockerModule/screenShotToken', {
        lockerId: this.lockerId
      });
    }

    protected showScreenShot() {
       this.showScreenShotDialog = true;
    }
    protected onTakeScreenShot() {
        this.takeScreenShotLoading = true;
        this.$store.dispatch('lockerModule/takeScreenShot', {
          lockerId: this.lockerId
        });
    }
    protected screenShotTokenOk() {
      this.screenShotUrl = settings.endpoint + 'lockers/' + this.lockerId + '/screenshot.jpg?t='
          + this.screenShotToken + '&r=' + Math.floor((Math.random() * 89999) + 10000);
    }
    private onSubmitting() {
      this.takeScreenShotLoading = true;
    }
    private onSubmittingEnd() {
      this.takeScreenShotLoading = false;
    }
  }

